import { render } from "./sim-current-session.vue?vue&type=template&id=08af7a6a&scoped=true"
import script from "./sim-current-session.vue?vue&type=script&lang=js"
export * from "./sim-current-session.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-08af7a6a"

export default script